<template>
  <div>
    <v-toolbar dark color="primary">
      <v-toolbar-title>
        <div class="d-flex flex-column">
          <strong>وبکارت</strong>
          <small v-if="POM == 'P'" class="text-muted text-small">گزارش کارکرد دوره ای پرسنل</small>
          <small v-if="POM == 'M'" class="text-muted text-small">گزارش کارکرد ماهانه پرسنل</small>
        </div>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <div id="viewer" dir="ltr"></div>
  </div>
</template>

<script>
import personelMonthWorkReportFile from "../../assets/reports/personelMonthWork.mrt";
import personelPeriodWorkReportFile from "../../assets/reports/personelPeriodWork.mrt";
import reportTexts from "../../assets/js/reports";
import EosUtils from "../../utils/EosUtils";
import ResultType from "../../model/ResultType";

export default {
  data() {
    return {
      visible: false,
      dataLoaded: false,
      infoDataSet: null,
      personelIOInfo: null,
      perno: "",
      sectionCode: "",
      year: "",
      period: "",
      POM: "",
    };
  },
  mounted() {
    this.loadPage();
  },
  watch: {
    dataLoaded(newVal) {
      if (newVal) {
        this.showReport();
      }
    },
  },
  methods: {
    loadPage() {
      var args = this.$route.query;
      this.perno = this.$store.state.auth.auth.username;
      this.sectionCode = args.SC;
      this.year = args.Y;
      this.period = args.P;
      this.POM = args.POM;

      this.ValidateQueryInputs();
      this.getData();
    },
    ValidateQueryInputs() {
      if (!this.perno) {
        this.transferPage();
      }
      if (!this.sectionCode) {
        this.transferPage();
      }
      if (!this.year) {
        this.transferPage();
      }
      if (!this.period) {
        this.transferPage();
      }
      if (!this.POM) {
        this.transferPage();
      }
    },
    transferPage() {
      //todo : error wrong page
    },
    async getData() {
      var moment = require("jalali-moment");

      var infoDataSet = {};
      if (EosUtils.isWebKartAdmin()) {
        infoDataSet.perno = "-";
        infoDataSet.personName = "مدير وب کارت";
      } else {
        infoDataSet.perno = this.perno;
        infoDataSet.personName =
          this.$store.state.personel.personelDetail.PersonName;
      }

      infoDataSet.timeNow = moment().locale("fa").format("YYYY/MM/DD HH:mm");
      infoDataSet.companyName = "";
      var GetCustomerNameResponse = await this.$store.dispatch(
        "lock/GetCustomerName"
      );
      if (GetCustomerNameResponse.type == ResultType.success) {
        infoDataSet.companyName = GetCustomerNameResponse.data;
      }

      infoDataSet.year = this.year;
      infoDataSet.period = this.period;
      if (
        this.sectionCode == "0" ||
        this.sectionCode == "" ||
        this.sectionCode == "-1"
      ) {
        //sectionCode = "";
        infoDataSet.sectionCode = "-";
        infoDataSet.sectionName = "تمام قسمت ها";
      } else {
        infoDataSet.sectionCode = this.sectionCode;
        infoDataSet.sectionName = "";

        var findSectionNameResponse = await this.$store.dispatch(
          "sections/findSectionName",
          {
            data: {
              sectionCode: this.sectionCode,
            },
          }
        );
        if (findSectionNameResponse.type == ResultType.success) {
          infoDataSet.sectionName = findSectionNameResponse.data;
        }
      }

      this.infoDataSet = infoDataSet;
      debugger
      if (this.POM == "P") {
        this.getPersonelPeriodWork();
      } else if (this.POM == "M") {
        this.getPersonelMonthWork();
      }
    },
    getPersonelPeriodWork() {
      const params = new URLSearchParams();
      params.append("month", this.period);
      params.append("year", this.year);
      params.append("sectioncode", this.sectionCode);
      params.append("isperiod", true);

      this.$store
        .dispatch("GetPersonelMonthWork", { params })
        .then((result) => {
          //console.log(result);
          if (result.type === "success") {
            this.personelIOInfo = result.data;
            this.dataLoaded = true;
          }
        });
    },
    getPersonelMonthWork() {
      const params = new URLSearchParams();
      params.append("month", this.period);
      params.append("year", this.year);
      params.append("sectioncode", this.sectionCode);
      params.append("isperiod", false);

      this.$store
        .dispatch("GetPersonelMonthWork", { params })
        .then((result) => {
          //console.log(result);
          if (result.type === "success") {
            this.personelIOInfo = result.data;
            this.dataLoaded = true;
          }
        });
    },
    showReport() {
      window.Stimulsoft.Base.StiLicense.key = reportTexts.getStimulKey();
      let options = new window.Stimulsoft.Viewer.StiViewerOptions();
      /*options.appearance.fullScreenMode = true;
      options.toolbar.displayMode =
        window.Stimulsoft.Viewer.StiToolbarDisplayMode.Separated;*/
      var viewer = new window.Stimulsoft.Viewer.StiViewer(
        options,
        "StiViewer",
        false
      );

      let report = window.Stimulsoft.Report.StiReport.createNewReport();

      if (this.POM == "P") {
        report.load(personelPeriodWorkReportFile);
      } else if (this.POM == "M") {
        report.load(personelMonthWorkReportFile);
      }

      report.dictionary.variables.getByName("sectionCode").valueObject =
        this.infoDataSet.sectionCode;
      report.dictionary.variables.getByName("sectionName").valueObject =
        this.infoDataSet.sectionName;
      report.dictionary.variables.getByName("ReportDate").valueObject =
        this.infoDataSet.timeNow;
      report.dictionary.variables.getByName("CompanyName").valueObject =
        this.infoDataSet.companyName;
      report.dictionary.variables.getByName("period").valueObject =
        this.infoDataSet.period;
      report.dictionary.variables.getByName("year").valueObject =
        this.infoDataSet.year;
      report.dictionary.variables.getByName("Perno").valueObject =
        this.infoDataSet.perno;
      report.dictionary.variables.getByName("PersonName").valueObject =
        this.infoDataSet.personName;

      report.regData("d1", "d1", this.personelIOInfo);

      viewer.report = report;
      viewer.renderHtml("viewer");
    },
  },
};
</script>

<style>
</style>